import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Summer/Statistics/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Statistics',
  weeks: [10, 11],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Statistics/1InterpretPictograms" */ './1InterpretPictograms'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Statistics/2DrawPictograms" */ './2DrawPictograms'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Statistics/3InterpretBarCharts" */ './3InterpretBarCharts'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Statistics/4DrawBarCharts" */ './4DrawBarCharts')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Statistics/5CollectAndRepresentData" */ './5CollectAndRepresentData'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Statistics/6TwoWayTables" */ './6TwoWayTables')
    })
  ]
});
export default Block;
